<template>
  <ul class="customer-tree">
    <li v-for="item in list" :key="item.deptId">
      <span class="title" @click="showUser(item)">
        <a-icon type="caret-right" v-show="!item.showUser"/>
        <a-icon type="caret-down" v-show="item.showUser"/>
        {{ item.deptName }}
      </span>
      <div v-show="item.showUser">
        <ul v-if="item.children">
          <tree :list="item.children" :selectedUser="selectedUser" :userName="userName" :detph="detph+1"
                @change="checkedUser"></tree>
        </ul>
        <ul>
          <li v-for="user in item.userList" :key="user.userId">
            <a-checkbox :checked="user.checked" @click="onChange(user)">
              {{ user.userName }}
            </a-checkbox>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import {dataApi} from '@/services/comm/userPicker.js';

export default {
  name: "Tree",
  props: {
    // 接收标题
    list: {
      type: Array
    },
    selectedUser: {
      type: Array
    },
    // 用来接收层数
    detph: {
      type: Number
    },
    userName: {
      type: String
    }
  },
  mounted() {
    this.list.forEach(item => {
      item.showUser = false
    })
    this.$forceUpdate()
  },
  data() {
    return {}
  },
  methods: {
    onChange(user) {
      user.checked = !user.checked
      this.$emit('change', user)
      this.$forceUpdate()
    },
    showUser(item) {
      console.log(' showUser(item) {')
      item.showUser = !item.showUser
      const ids = this.selectedUser.map(item => {
        return item.userId
      })
      // console.log(ids)
      dataApi.selectUserListByDeptId(item.deptId, this.userName).then(res => {
        item.userList = res.data.map(item => {
          item.checked = ids.includes(item.userId)
          return item
        })
        this.$forceUpdate()
      })
    },
    checkedUser(user) {
      this.$emit('change', user)
    }
  }
}
</script>

<style scoped lang="less">
ul {
  padding-left: 12px;
  list-style-type: none;

  li {
    line-height: 24px;
    margin-top: 6px;

  }
}

.customer-tree {

  .title {
    cursor: pointer;

    &:hover {
      background-color: #91a1a0;
    }

    i {
      margin-right: 4px;
    }
  }
}
</style>
